import React from 'react';
import { ArrowRight, Download, Copy, Bot } from 'lucide-react';
interface ProductPresentationProps {
  onScrollToOffer: () => void;
}
export function ProductPresentation({
  onScrollToOffer
}: ProductPresentationProps) {
  const steps = [{
    icon: <Download className="w-8 h-8 text-[#00B4D8]" data-id="element-185" />,
    title: '1. Descargás el pack',
    description: '(un ZIP con todos los archivos organizados por módulo)'
  }, {
    icon: <Copy className="w-8 h-8 text-[#00B4D8]" data-id="element-186" />,
    title: '2. Copiás las instrucciones',
    description: 'de la skill que necesitás y las pegás en un Proyecto de Claude'
  }, {
    icon: <Bot className="w-8 h-8 text-[#00B4D8]" data-id="element-187" />,
    title: '3. Claude se convierte',
    description: 'en ese especialista y trabaja con frameworks probados, no con respuestas genéricas'
  }];
  return <section className="py-20 px-4" data-id="element-188">
      <div className="max-w-5xl mx-auto" data-id="element-189">
        <div className="text-center mb-16" data-id="element-190">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-191">
            Presentamos InfoSkills Pro
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-192">
            Es un kit de 33 skills (instrucciones especializadas) que convierten
            a Claude en tu equipo completo de marketing, contenido y gestión
            para infoproductos.
          </p>
          <p className="text-lg text-[#00B4D8] mt-4 font-medium max-w-3xl mx-auto" data-id="element-193">
            No son prompts genéricos. No son "500 prompts para todo". Son 33
            sistemas de trabajo probados, diseñados específicamente para el
            negocio de infoproductos.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-sm mb-16" data-id="element-194">
          <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-195">
            Cómo funciona:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-196">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-197">
                <div className="bg-[#00B4D8]/20 p-4 rounded-full mb-4" data-id="element-198">
                  {step.icon}
                </div>
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-199">
                  {step.title}
                </h4>
                <p className="text-gray-400" data-id="element-200">{step.description}</p>
              </div>)}
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#0B1D3A] via-[#1a365d] to-[#0B1D3A] border border-[#00B4D8]/30 rounded-2xl p-8 text-center mb-12" data-id="element-201">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-202">
            ¿Necesitás una landing?{' '}
            <span className="text-white font-bold" data-id="element-203">
              Activás la skill #15 y tenés el copy en 10 minutos.
            </span>
            <br className="hidden md:block" data-id="element-204" />
            ¿Necesitás ads?{' '}
            <span className="text-white font-bold" data-id="element-205">
              Activás la #22 y tenés 10 ángulos publicitarios.
            </span>
            <br className="hidden md:block" data-id="element-206" />
            ¿Necesitás organizar tu lanzamiento?{' '}
            <span className="text-white font-bold" data-id="element-207">
              La #7 te arma el plan día por día.
            </span>
          </p>
        </div>

        <div className="flex justify-center" data-id="element-208">
          <button onClick={onScrollToOffer} className="bg-[#27AE60] hover:bg-[#219653] text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(39,174,96,0.4)] hover:shadow-[0_0_40px_rgba(39,174,96,0.6)] transition-all flex items-center gap-3 transform hover:-translate-y-1 w-full md:w-auto justify-center" data-id="element-209">
            Quiero escalar mi infoproducto con IA{' '}
            <ArrowRight className="w-6 h-6" data-id="element-210" />
          </button>
        </div>
      </div>
    </section>;
}